import {
    FETCH_QUESTIONS_REQUEST,
    FETCH_QUESTIONS_SUCCESS,
    FETCH_QUESTIONS_FAILURE,

    CREATE_QUESTION_REQUEST,
    CREATE_QUESTION_SUCCESS,
    CREATE_QUESTION_FAILURE,

    UPDATE_QUESTION_REQUEST,
    UPDATE_QUESTION_SUCCESS,
    UPDATE_QUESTION_FAILURE,

    DELETE_QUESTION_REQUEST,
    DELETE_QUESTION_SUCCESS,
    DELETE_QUESTION_FAILURE,
} from "../actions/types";


const initialState = {

    questions: [],

    loading: false,

    error: null,

    message: "",

};


const questionReducer = (
    state = initialState,
    action
) => {

    switch (action.type) {


        case FETCH_QUESTIONS_REQUEST:

            return {
                ...state,

                loading: true,

                error: null,
            };


        case FETCH_QUESTIONS_SUCCESS:

            return {

                ...state,

                loading: false,

                questions:
                    Array.isArray(
                        action.payload
                    )
                        ? action.payload
                        : [],

                message:
                    "Questions loaded successfully",
            };


        case FETCH_QUESTIONS_FAILURE:

            return {

                ...state,

                loading: false,

                error:
                    action.payload,

                questions: [],
            };



        case CREATE_QUESTION_REQUEST:

            return {

                ...state,

                loading: true,

                error: null,
            };


        case CREATE_QUESTION_SUCCESS:

            return {

                ...state,

                loading: false,

                questions: [
                    ...state.questions,
                    action.payload,
                ],

                message:
                    "Question created successfully",
            };


        case CREATE_QUESTION_FAILURE:

            return {

                ...state,

                loading: false,

                error:
                    action.payload,
            };


        case UPDATE_QUESTION_REQUEST:

            return {

                ...state,

                loading: true,

                error: null,
            };


        case UPDATE_QUESTION_SUCCESS:

            return {

                ...state,

                loading: false,

                questions:
                    state.questions.map(
                        (question) =>
                            question.question_id ===
                            action.payload.question_id
                                ? {
                                    ...question,
                                    ...action.payload,
                                }
                                : question
                    ),

                message:
                    "Question updated successfully",
            };


        case UPDATE_QUESTION_FAILURE:

            return {

                ...state,

                loading: false,

                error:
                    action.payload,
            };


        case DELETE_QUESTION_REQUEST:

            return {

                ...state,

                loading: true,

                error: null,
            };


        case DELETE_QUESTION_SUCCESS:

            return {

                ...state,

                loading: false,

                questions:
                    state.questions.filter(
                        (question) =>
                            question.question_id !==
                            action.payload
                    ),

                message:
                    "Question deleted successfully",
            };


        case DELETE_QUESTION_FAILURE:

            return {

                ...state,

                loading: false,

                error:
                    action.payload,
            };


        default:

            return state;

    }

};


export default questionReducer;